import { Features } from "../../assets/features/Features";

export const ROUTES = {
  // Main routes
  HOME: "/",
  CONTACT: "/contact",
  
  // Clinic routes
  ABOUT_US: "/clinic/about-us",
  GALLERY: "/clinic/gallery",
  LOCATION: "/clinic/location",
  ARBITRATION: "/clinic/arbitration",
  TERMOS: "/clinic/termos",
  PRIVACY: "/clinic/privacy",
  COOKIES: "/clinic/cookies",
  
  // Services routes
  SERVICES: "/services",
  OSTEOPATHY: "/services/osteopathy",
  PHYSIOTHERAPY: "/services/physiotherapy",
  CHIROPRACTIC: "/services/chiropractic",
  SPORTS_MASSAGE: "/services/sports-massage",
  PAIN_TREATMENT: "/services/pain-treatment",
  AURICULOTHERAPY: "/services/auriculotherapy",
  POSTURAL_ALIGNMENT: "/services/postural-alignment",
  CUPPING_THERAPY: "/services/cupping-therapy",
  CLINICAL_PILATES: "/services/clinical-pilates",
  
  // Admin routes
  ADMIN: "/admin",
  ADMIN_LOGIN: "/admin/login",
};

export default ROUTES; 